
// eslint-disable-next-line import/no-cycle
import { getScrollingManager } from '../../mobile-library/contentFrameInternals/getScrollingManager';
import { isWebApp } from '../../utils/environment';
import { ScrollingManagerCore } from './ScrollingManagerCore';
import { WebScrollingManager } from './webScrollingManager';


export function getCoreScrollingManager(): ScrollingManagerCore {
  let scrollingManagerInstance: ScrollingManagerCore | null = null;
  if (!scrollingManagerInstance) {
    if (isWebApp) {
      scrollingManagerInstance = new WebScrollingManager();
    } else {
      scrollingManagerInstance = getScrollingManager('getCoreScrollingManager');
    }
  }

  return scrollingManagerInstance;
}
